<template>
  <GmbRow :controlValue="itemId" :isRadioButton="!isForDisplay">
    <template #picto>
      <FdText fa>
        <i
            :class="[
            'fas',
            {
              'fa-user-tie': client && !project && !organization,
            },
            {
              'fa-folder': project && !organization,
            },
            {
              'fa-building': organization,
            },
          ]"
        />
      </FdText>
    </template>

    <div class="row no-gutters align-items-center">
      <div
          class="d-flex col-6 pr-2 align-items-center gmb-obsbox-item__primary-info-column"
      >
        <template v-if="organization">
          <FdText oneline tag="span">{{ organization }}</FdText>
        </template>

        <template v-else-if="project">
          <FdText oneline tag="span">{{ project }}</FdText>
        </template>

        <template v-else>
          <!-- necessarily "client" is set! -->
          <FdText oneline tag="span">{{ client }}</FdText>
        </template>
      </div>

      <div
          class="d-flex col-6 pl-2 justify-content-end gmb-obsbox-item__secondary-info-column"
      >
        <div
            :class="[
            'd-flex align-items-center',
            {
              'maxw-50 pr-1': client && project && organization,
            },
          ]"
        >
          <template v-if="client && (project || organization)">
            <FdText fa>
              <i class="fas fa-user-tie"/>
            </FdText>
            <FdText class="ml-1" fontSizeSmaller2 oneline tag="span">{{
                client
              }}
            </FdText>
          </template>
        </div>
        <div
            :class="[
            'd-flex maxw-50 align-items-center',
            {
              'pl-1': client && project && organization,
            },
          ]"
        >
          <template v-if="project && organization">
            <FdText fa>
              <i class="fas fa-folder"/>
            </FdText>
            <FdText class="ml-1" fontSizeSmaller2 oneline tag="span">{{
                project
              }}
            </FdText>
          </template>
        </div>
      </div>
    </div>
  </GmbRow>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";

export default {
  name: "GmbObsboxItem",

  components: {
    FdText,
    GmbRow,
  },

  props: {
    client: String,
    isForDisplay: Boolean,
    itemId: String,
    organization: String,
    project: String,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/fonts";

/* =========================================================================
 * OBSBOX ITEM
 * ========================================================================= */

.gmb-obsbox-item {
  &__primary-info-column {
  }

  &__secondary-info-column {
    // font-size: $gmb-font-size-smaller-1;
    color: $gmb-color-white;
  }
}
</style>
